import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import { Router } from '@angular/router';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { _HttpClient } from '@delon/theme';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectModule } from 'ng-zorro-antd/select';
// import { AccountCodeComponent } from 'src/app/components/modal/account-code/account-code-modal.component';
import { ViewItemComponent } from 'src/app/shared/components/view-item/view-item.component';

import { SelectInstantBaseComponent } from '../selectInstant-base';

@Component({
  selector: 'app-gl-acc-select',
  templateUrl: './gl-account-select.component.html',
  styleUrls: ['./gl-account-select.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzSelectModule,
    NzButtonModule,
    NzIconModule,
    ViewItemComponent,
    // AccountCodeComponent
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GLAccountSelectComponent),
      multi: true
    }
  ]
})
export class GLAccountSelectComponent
  extends SelectInstantBaseComponent
  implements OnInit
{
  // @ViewChild('codeModal', { static: true })
  // accCodeModalComponent!: AccountCodeComponent;

  notShowInReport: boolean = false;

  @Input() includeAplac: boolean = false;
  @Input() includeDACandCCAC: boolean = false;
  accCodes: string[] = ['ADA','BAC','BOAC','CAC','MAC','PT','ST'];

  constructor(
    http: _HttpClient,
    cdr: ChangeDetectorRef,
    router: Router,
    private resueTabService: ReuseTabService
  ) {
    super(http, cdr, router);
    this.valueField = 'id';
  }

  ngOnInit(): void {
    this.checkAddNewOptionInReportAccess();
  }

  getUrl(searchValue: string): string {
    //let url = `api/accountcodes/search?$count=false&$top=50&$skip=0&$filter=IsActive eq true and ((SpecialCode eq null or SpecialCode eq '') or (SpecialCode eq 'ADA' or SpecialCode eq 'BAC' or SpecialCode eq 'BOAC' or SpecialCode eq 'CAC' or SpecialCode eq 'MAC' or SpecialCode eq 'PT' or SpecialCode eq 'ST' ${this.includeAplac ? "or SpecialCode eq 'APLAC'" : ""}))`;
    if (this.includeAplac)
      this.accCodes.push('APLAC');
    if (this.includeDACandCCAC){
      this.accCodes.push('DAC');
      this.accCodes.push('CCAC');
    }
    
    const accCodesString = this.accCodes.map(c => `'${c}'`).join(',');
    let url = `api/accountcodes/search?$count=false&$top=50&$skip=0&$filter=IsActive eq true and ((SpecialCode eq null or SpecialCode eq '') or SpecialCode in (${accCodesString}))`;
    if (searchValue && searchValue.trim()) {
      url = `${url}&keyword=${encodeURIComponent(searchValue.trim())}`;
    } else {
      url = `${url}&$orderby=code asc`;
    }
    return url;
  }

  @Input() labelField: 'code' | 'name' | null = null;

  getLabel(item: any) {
    if (item) {
      if (this.labelField === 'code') return item.code;
      else if (this.labelField === 'name') return item.name;
      return `${item.code} - ${item.name}`;
    }
    return '';
  }

  // set the location want to navigate
  jump(): string {
    return '/gl/coa';
  }

  // set the param
  queryParam(): String {
    return 'AccountCode';
  }

  onSubmit(account: any) {
    this.selected = account;
    // TO-DO: assign the created account as current selected value
  }

  override valueChanged(val: any): void {
    if (val === 'addNew') {
      this.addNew();
      //this.instantData = '';
    } else {
      super.valueChanged(val);
    }
  }

  override addNew() {
    super.addNew();
    // this.accCodeModalComponent.new({
    //   parentId: '',
    //   isActive: true,
    //   name: this.instantData
    // });

    // setTimeout(() => {
    //   this.clearSelection();
    // }, 50);
  }

  checkAddNewOptionInReportAccess(): boolean {
    let curUrl = this.resueTabService.curUrl.toLowerCase();

    if (curUrl.includes('report')) {
      this.notShowInReport = true;
    } else {
      this.notShowInReport = false;
    }

    return this.notShowInReport;
  }

  focus() {
    if (this.selector) {
      this.selector.focus();
    }
  }

}
